export default "__VITE_ASSET__563aebbd__"